import { render, staticRenderFns } from "./BaseCardBadge.vue?vue&type=template&id=aafa7534&scoped=true&"
import script from "./BaseCardBadge.vue?vue&type=script&lang=js&"
export * from "./BaseCardBadge.vue?vue&type=script&lang=js&"
import style0 from "./BaseCardBadge.vue?vue&type=style&index=0&id=aafa7534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafa7534",
  null
  
)

export default component.exports